import React from 'react';
import { Button } from 'antd';
import { PatchBillingInfoUser } from 'lib.store/src/main/billing/models';
import { ErrorsValues } from 'lib.shared/src/billing/drawers/models';
import BillingForm from 'lib.components/src/components/BillingForm';
import { DrawerCustom } from 'lib.components';
import { useBreakpoints } from 'lib.hooks/src';

interface BillingInfoDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  form: PatchBillingInfoUser;
  onValuesChange: (field: Partial<PatchBillingInfoUser>) => void;
  errors: ErrorsValues;
  isLoading: boolean;
  onSubmit: () => void;
  title?: string;
}

const BillingInfoDrawer: React.FC<BillingInfoDrawerProps> = ({
  isOpen,
  onClose,
  form,
  onValuesChange,
  errors,
  isLoading,
  onSubmit,
  title = 'Billing info',
}) => {
  const { md: isDesktop } = useBreakpoints();
  const content = isOpen ? (
    <BillingForm
      form={form}
      validationErrors={errors}
      onFormChange={onValuesChange as (values: Partial<PatchBillingInfoUser>) => void}
    />
  ) : null;

  return (
    <DrawerCustom
      title={title}
      open={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onOk={onSubmit}
      resetButtonText="Cancel"
      applyButtonText="Save"
      isLoading={isLoading}
      footer={
        isDesktop ? (
          <div className="drawer-footer flex gap-12">
            <Button size="large" block type="text" onClick={onClose}>
              Cancel
            </Button>
            <Button size="large" block type="primary" onClick={onSubmit} loading={isLoading}>
              Save
            </Button>
          </div>
        ) : undefined
      }
    >
      {isOpen ? (
        <div className="w-full" data-test-id="billing-info-drawer">
          {content}
        </div>
      ) : null}
    </DrawerCustom>
  );
};

export default BillingInfoDrawer;
